// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v5.27.1
// source: enums.proto

/* eslint-disable */

export const protobufPackage = "";

export enum AuditStatus {
  AUDITSTATUSUNKNOWN = 0,
  AUDITSTATUSPASS = 1,
  AUDITSTATUSFAILED = 2,
  AUDITSTATUSREVIEWING = 3,
  AUDITSTATUSFORBIDDEN = 4,
  UNRECOGNIZED = -1,
}

export enum EmoteType {
  EMOTETYPENORMAL = 0,
  EMOTETYPEWITHSTICKER = 1,
  UNRECOGNIZED = -1,
}

export enum ContentSource {
  CONTENTSOURCEUNKNOWN = 0,
  CONTENTSOURCENORMAL = 1,
  CONTENTSOURCECAMERA = 2,
  UNRECOGNIZED = -1,
}

export enum EmotePrivateType {
  EMOTE_PRIVATE_TYPE_NORMAL = 0,
  EMOTE_PRIVATE_TYPE_SUB_WAVE = 1,
  UNRECOGNIZED = -1,
}

export enum TextType {
  DISPLAY_TEXT = 0,
  CONTENT = 1,
  UNRECOGNIZED = -1,
}

export enum LinkmicApplierSortSetting {
  LINKMIC_APPLIER_SORT_SETTING_NONE = 0,
  LINKMIC_APPLIER_SORT_SETTING_BY_GIFT_SCORE = 1,
  UNRECOGNIZED = -1,
}

export enum HashtagNamespace {
  GLOBAL = 0,
  GAMING = 1,
  UNRECOGNIZED = -1,
}

export enum AgreeStatus {
  AGREE_UNKNOWN = 0,
  AGREE = 1,
  REJECT = 2,
  UNRECOGNIZED = -1,
}

export enum KickoutReason {
  KICKOUT_REASON_UNKNOWN = 0,
  KICKOUT_REASON_FIRST_FRAME_TIMEOUT = 1,
  KICKOUT_REASON_BY_HOST = 2,
  KICKOUT_REASON_RTC_LOST_CONNECTION = 3,
  KICKOUT_REASON_BY_PUNISH = 4,
  KICKOUT_REASON_BY_ADMIN = 5,
  KICKOUT_REASON_HOST_REMOVE_ALL_GUESTS = 6,
  UNRECOGNIZED = -1,
}

export enum GroupStatus {
  GROUP_STATUS_UNKNOWN = 0,
  GROUP_STATUS_WAITING = 1,
  GROUP_STATUS_LINKED = 3,
  UNRECOGNIZED = -1,
}

export enum BusinessCase {
  BUSINESS_NOT_SET = 0,
  APPLY_BIZ_CONTENT = 1,
  INVITE_BIZ_CONTENT = 2,
  REPLY_BIZ_CONTENT = 3,
  PERMIT_BIZ_CONTENT = 4,
  JOIN_DIRECT_BIZ_CONTENT = 5,
  KICK_OUT_BIZ_CONTENT = 6,
  LIST_CHANGE_BIZ_CONTENT = 11,
  MULTI_LIVE_CONTENT = 100,
  COHOST_CONTENT = 200,
  UNRECOGNIZED = -1,
}

export enum ReplyStatus {
  REPLY_STATUS_UNKNOWN = 0,
  REPLY_STATUS_AGREE = 1,
  REPLY_STATUS_REFUSE_PERSONALLY = 2,
  REPLY_STATUS_REFUSE_TYPE_NOT_SUPPORT = 3,
  REPLY_STATUS_REFUSE_PROCESSING_INVITATION = 4,
  REPLY_STATUS_REFUSE_BY_TIMEOUT = 5,
  REPLY_STATUS_REFUSE_EXCEPTION = 6,
  REPLY_STATUS_REFUSE_SYSTEM_NOT_SUPPORTED = 7,
  REPLY_STATUS_REFUSE_SUBTYPE_DIFFERENCE = 8,
  REPLY_STATUS_REFUSE_IN_MICROOM = 9,
  REPLY_STATUS_REFUSE_NOT_LOAD_PLUGIN = 10,
  REPLY_STATUS_REFUSE_IN_MULTI_GUEST = 11,
  REPLY_STATUS_REFUSE_PAUSE_LIVE = 12,
  REPLY_STATUS_REFUSE_OPEN_CAMERA_DIALOG_SHOWING = 13,
  REPLY_STATUS_REFUSE_DRAW_GUESSING = 14,
  REPLY_STATUS_REFUSE_RANDOM_MATCHING = 15,
  REPLY_STATUS_REFUSE_IN_MATCH_PROCESSING = 16,
  REPLY_STATUS_REFUSE_IN_MICROOM_FOR_MULTI_COHOST = 17,
  REPLY_STATUS_REFUSE_COHOST_FINISHED = 18,
  REPLY_STATUS_REFUSE_NOT_CONNECTED = 19,
  REPLY_STATUS_REFUSE_LINKMIC_FULL = 20,
  REPLY_STATUS_REFUSE_ARC_INCOMPATIBLE = 21,
  REPLY_STATUS_REFUSE_PROCESSING_OTHER_INVITE = 22,
  REPLY_STATUS_REFUSE_PROCESSING_OTHER_APPLY = 23,
  REPLY_STATUS_REFUSE_IN_ANCHOR_COHOST = 24,
  REPLY_STATUS_REFUSE_TOPIC_PAIRING = 25,
  UNRECOGNIZED = -1,
}

export enum SubscribeType {
  SUBSCRIBETYPE_ONCE = 0,
  SUBSCRIBETYPE_AUTO = 1,
  SUBSCRIBETYPE_DEFAULT = 100,
  UNRECOGNIZED = -1,
}

export enum OldSubscribeStatus {
  OLD_SUBSCRIBE_STATUS_FIRST = 0,
  OLD_SUBSCRIBE_STATUS_RESUB = 1,
  OLD_SUBSCRIBE_STATUS_SUBIN_GRACE_PERIOD = 2,
  OLD_SUBSCRIBE_STATUS_SUB_NOTIN_GRACE_PERIOD = 3,
  OLD_SUBSCRIBE_STATUS_DEFAULT = 100,
  UNRECOGNIZED = -1,
}

export enum SubscribingStatus {
  SUBSCRIBING_STATUS_UNKNOWN = 0,
  SUBSCRIBING_STATUS_ONCE = 1,
  SUBSCRIBING_STATUS_CIRCLE = 2,
  SUBSCRIBING_STATUS_CIRCLE_CANCEL = 3,
  SUBSCRIBING_STATUS_REFUND = 4,
  SUBSCRIBING_STATUS_IN_GRACE_PERIOD = 5,
  SUBSCRIBING_STATUS_NOT_IN_GRACE_PERIOD = 6,
  UNRECOGNIZED = -1,
}

export enum LinkmicStatus {
  Disable = 0,
  Enable = 1,
  Just_Following = 2,
  Multi_Linking = 3,
  Multi_Linking_Only_Following = 4,
  UNRECOGNIZED = -1,
}

export enum MemberMessageAction {
  UNKNOWN = 0,
  /** JOINED - User Joined the Stream */
  JOINED = 1,
  /** SUBSCRIBED - User Subscribed to the Host */
  SUBSCRIBED = 3,
  UNRECOGNIZED = -1,
}

export enum ControlAction {
  CONTROL_ACTION_FALLBACK_UNKNOWN = 0,
  CONTROL_ACTION_STREAM_PAUSED = 1,
  CONTROL_ACTION_STREAM_UNPAUSED = 2,
  CONTROL_ACTION_STREAM_ENDED = 3,
  CONTROL_ACTION_STREAM_SUSPENDED = 4,
  UNRECOGNIZED = -1,
}

export enum LinkLayerMessageType {
  Linker_Unknown = 0,
  Linker_Create = 1,
  Linker_Invite = 2,
  Linker_Apply = 3,
  Linker_Permit = 4,
  Linker_Reply = 5,
  Linker_Kick_Out = 6,
  Linker_Cancel_Apply = 7,
  Linker_Cancel_Invite = 8,
  Linker_Leave = 9,
  Linker_Finish = 10,
  Linker_List_Change = 11,
  Linker_Join_Direct = 12,
  Linker_Join_Group = 13,
  Linker_Permit_Group = 14,
  Linker_Cancel_Group = 15,
  Linker_Leave_Group = 16,
  Linker_P2P_Group_Change = 17,
  Linker_Group_Change = 18,
  UNRECOGNIZED = -1,
}

export enum BarrageType {
  BarrageType_Unknown = 0,
  EComOrdering = 1,
  EComBuying = 2,
  Normal = 3,
  Subscribe = 4,
  EventView = 5,
  EventRegistered = 6,
  SubscribeGift = 7,
  UserUpgrade = 8,
  GradeUserEntranceNotification = 9,
  FansLevelUpgrade = 10,
  FansLevelEntrance = 11,
  GamePartnership = 12,
  UNRECOGNIZED = -1,
}

export enum EnvelopeBusinessType {
  BusinessTypeUnknown = 0,
  BusinessTypeUserDiamond = 1,
  BusinessTypePlatformDiamond = 2,
  BusinessTypePlatformShell = 3,
  BusinessTypePortal = 4,
  BusinessTypePlatformMerch = 5,
  BusinessTypeEoYDiamond = 6,
  BusinessTypeFanClubGtM = 7,
  UNRECOGNIZED = -1,
}

export enum EnvelopeFollowShowStatus {
  ENVELOPE_FOLLOW_SHOW_STATUS_ENVELOPE_FOLLOW_SHOW_UNKNOWN = 0,
  ENVELOPE_FOLLOW_SHOW_STATUS_ENVELOPE_FOLLOW_SHOW = 1,
  ENVELOPE_FOLLOW_SHOW_STATUS_ENVELOPE_FOLLOW_NOT_SHOW = 2,
  UNRECOGNIZED = -1,
}

export enum EnvelopeDisplay {
  ENVELOPE_DISPLAY_UNKNOWN = 0,
  ENVELOPE_DISPLAY_NEW = 1,
  ENVELOPE_DISPLAY_HIDE = 2,
  UNRECOGNIZED = -1,
}

export enum CommonContentCase {
  COMMON_CONTENT_NOT_SET = 0,
  CREATE_CHANNEL_CONTENT = 100,
  LIST_CHANGE_CONTENT = 102,
  INVITE_CONTENT = 103,
  APPLY_CONTENT = 104,
  PERMIT_APPLY_CONTENT = 105,
  REPLY_INVITE_CONTENT = 106,
  KICK_OUT_CONTENT = 107,
  CANCEL_APPLY_CONTENT = 108,
  CANCEL_INVITE_CONTENT = 109,
  LEAVE_CONTENT = 110,
  FINISH_CONTENT = 111,
  JOIN_DIRECT_CONTENT = 112,
  JOIN_GROUP_CONTENT = 113,
  PERMIT_GROUP_CONTENT = 114,
  CANCEL_GROUP_CONTENT = 115,
  LEAVE_GROUP_CONTENT = 116,
  P2P_GROUP_CHANGE_CONTENT = 117,
  GROUP_CHANGE_CONTENT = 118,
  UNRECOGNIZED = -1,
}

export enum LinkMessageType {
  TYPE_LINKER_UNKNOWN = 0,
  TYPE_LINKER_CREATE = 1,
  TYPE_LINKER_CLOSE = 2,
  TYPE_LINKER_INVITE = 3,
  TYPE_LINKER_APPLY = 4,
  TYPE_LINKER_REPLY = 5,
  TYPE_LINKER_ENTER = 6,
  TYPE_LINKER_LEAVE = 7,
  TYPE_LINKER_PERMIT = 8,
  TYPE_LINKER_CANCEL_INVITE = 9,
  TYPE_LINKER_WAITING_LIST_CHANGE = 10,
  TYPE_LINKER_LINKED_LIST_CHANGE = 11,
  TYPE_LINKER_UPDATE_USER = 12,
  TYPE_LINKER_KICK_OUT = 13,
  TYPE_LINKER_CANCEL_APPLY = 14,
  TYPE_LINKER_MUTE = 15,
  TYPE_LINKER_MATCH = 16,
  TYPE_LINKER_UPDATE_USER_SETTING = 17,
  TYPE_LINKER_MIC_IDX_UPDATE = 18,
  TYPE_LINKER_LEAVE_V2 = 19,
  TYPE_LINKER_WAITING_LIST_CHANGE_V2 = 20,
  TYPE_LINKER_LINKED_LIST_CHANGE_V2 = 21,
  TYPE_LINKER_COHOST_LIST_CHANGE = 22,
  TYPE_LINKER_MEDIA_CHANGE = 23,
  TYPE_LINKER_ACCEPT_NOTICE = 24,
  TYPE_LINKER_SYS_KICK_OUT = 101,
  TYPE_LINKMIC_USER_TOAST = 102,
  UNRECOGNIZED = -1,
}

export enum MessageType {
  MESSAGE_TYPE_SUB_SUCCESS = 0,
  MESSAGE_TYPE_ANCHOR_REMINDER = 1,
  MESSAGE_TYPE_ENTER_ROOM_EXPIRE_SOON = 2,
  MESSAGE_TYPE_SUB_GOAL_CREATE_TO_ANCHOR = 3,
  MESSAGE_TYPE_SUB_GOAL_COMPLETE_TO_AUDIENCE = 4,
  MESSAGE_TYPE_SUB_GOAL_COMPLETE_TO_ANCHOR = 5,
  MESSAGE_TYPE_SUB_GIFT_TIK_TOK_2_USER_NOTICE = 6,
  MESSAGE_TYPE_SUB_GIFT_TIK_TOK_2_ANCHOR_NOTICE = 7,
  MESSAGE_TYPE_SUB_GIFT_T_RECEIVES_END_NOTICE = 8,
  MESSAGE_TYPE_SUB_GIFTS_END_SUCCEED_ROOM_MESSAGE = 9,
  MESSAGE_TYPE_SUB_GIFTS_END_SUCCEED_ANCHOR_NOTICE = 10,
  MESSAGE_TYPE_SUB_GIFT_LOW_VERSION_UPGRADE_NOTICE = 11,
  MESSAGE_TYPE_SUB_GIFT_USER_BUY_AU_TH_NOTICE = 12,
  MESSAGE_TYPE_SUB_COMMON_TEXT_NOTICE = 13,
  MESSAGE_TYPE_SUB_MODERATOR_PIN_PERK = 14,
  UNRECOGNIZED = -1,
}

export enum Scene {
  SCENE_UNKNOWN = 0,
  SCENE_CO_HOST = 2,
  SCENE_MULTI_LIVE = 4,
  UNRECOGNIZED = -1,
}

export enum RewardCondition {
  REWARD_CONDITION_SUBSCRIPTION = 0,
  REWARD_CONDITION_SUB_WAVE_CUSTOM = 1,
  UNRECOGNIZED = -1,
}

export enum UserEmoteUploadSource {
  USER_EMOTE_UPLOAD_SOURCE_EMOTE_UPLOAD_SOURCE_ANCHOR = 0,
  USER_EMOTE_UPLOAD_SOURCE_EMOTE_UPLOAD_SOURCE_SUBSCRIBER = 1,
  USER_EMOTE_UPLOAD_SOURCE_EMOTE_UPLOAD_SOURCE_MODERATOR = 2,
  UNRECOGNIZED = -1,
}

export enum EmoteScene {
  EMOTE_SCENE_SUBSCRIPTION = 0,
  EMOTE_SCENE_GAME = 1,
  UNRECOGNIZED = -1,
}

export enum PunishTypeId {
  PUNISH_TYPE_IDUN_KNOWN = 0,
  PUNISH_TYPE_ID_BAN_LINK_MIC = 9,
  PUNISH_TYPE_ID_BAN_GAME_PARTNERSHIP = 25,
  PUNISH_TYPE_ID_REMOVE_GAME_PARTNERSHIP = 26,
  PUNISH_TYPE_ID_BANCO_HOST_LINK_MIC = 55,
  PUNISH_TYPE_ID_AUTHORITY_LIMIT_MATCH = 57,
  PUNISH_TYPE_ID_BAN_VOICE_CHAT = 59,
  PUNISH_TYPE_ID_BAN_LIVE_GOAL = 64,
  PUNISH_TYPE_ID_VIEWER_LIMIT = 70,
  UNRECOGNIZED = -1,
}

export enum MultiplierType {
  MULTIPLIER_TYPE_UNSPECIFIED = 0,
  MULTIPLIER_TYPE_CRITICAL_STRIKE = 1,
  MULTIPLIER_TYPE_TOP_2 = 2,
  MULTIPLIER_TYPE_TOP_3 = 3,
  UNRECOGNIZED = -1,
}

export enum LinkmicGiftExpressionStrategy {
  LINKMIC_GIFT_EXPRESSION_STRATEGY_CONTROL_V_1 = 0,
  LINKMIC_GIFT_EXPRESSION_STRATEGY_EXPERIMENT_V_1 = 1,
  LINKMIC_GIFT_EXPRESSION_STRATEGY_EXPERIMENT_V_2 = 2,
  UNRECOGNIZED = -1,
}

export enum GiftMessageVersion {
  GIFT_MESSAGE_VERSION_0 = 0,
  GIFT_MESSAGE_VERSION_1 = 1,
  UNRECOGNIZED = -1,
}

export enum TagType {
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_UNKNOWN = 0,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_USER_GRADE = 1,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_FANS_LEVEL = 2,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_WATCH_ME_DAYS_AGO = 3,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_CUSTOM = 4,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_TITLE_GIFT = 5,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_FIRST_JOINED_TEAM = 6,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_PAY_ACCOMPANY_DAYS = 7,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_SPONSOR_GIFT_LAST_ROOM = 8,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_MATCH_MVP_LAST_ROOM = 9,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_LARGE_AMOUNT_GIFT_LAST_ROOM = 10,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_COMMENT_LAST_ROOM = 11,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_RECENT_TITLED_GIFT = 12,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_MEET_ANNIVERSARY = 13,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_FANS_SLEEP = 14,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_NOT_SEND_HEART_ME = 15,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_NOT_JOIN_TEAM = 16,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_FIRST_WATCH_LIVE = 17,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_RECENT_COMMENT = 18,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_RECENT_GIFT_TIMES = 19,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_RECENT_WATCH_LIVE_DURATION = 20,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_RECENT_GIFT = 21,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_RECENT_LIVE_CONTRIBUTION_TOP = 22,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_JUST_UPGRADE = 28,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_FAN_TOTAL_WATCH_DURATION = 29,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_FAN_TOTAL_COMMENT_NUM = 30,
  TAG_TYPE_CREATOR_CR_M_TAG_TYPE_FAN_TOTAL_GIFT_SENT_NUM = 31,
  UNRECOGNIZED = -1,
}

export enum TopicActionType {
  TOPIC_ACTION_TYPE_UNKNOWN = 0,
  TOPIC_ACTION_TYPE_FOLLOW = 1,
  UNRECOGNIZED = -1,
}

export enum UserMetricsType {
  USER_METRICS_TYPE_UNKNOWN = 0,
  USER_METRICS_TYPE_GRADE = 1,
  USER_METRICS_TYPE_SUBSCRIBE = 2,
  USER_METRICS_TYPE_FOLLOW = 3,
  USER_METRICS_TYPE_FANS_CLUB = 4,
  USER_METRICS_TYPE_TOP_VIEWER = 5,
  USER_METRICS_TYPE_GIFT = 6,
  UNRECOGNIZED = -1,
}

export enum GiftMessageIgnoreConfig {
  GIFT_MESSAGE_IGNORE_CONFIG_NOT_IGNORE = 0,
  GIFT_MESSAGE_IGNORE_CONFIG_IGNORE_TRAY = 1,
  GIFT_MESSAGE_IGNORE_CONFIG_IGNORE_PS_M = 2,
  GIFT_MESSAGE_IGNORE_CONFIG_IGNORE_TRAY_AND_PS_M = 3,
  UNRECOGNIZED = -1,
}

export enum HorizontalOnclickTriggerType {
  HORIZONTAL_ONCLICK_TRIGGER_TYPE_ONCLICK_TRIGGER_TYPE_UNKNOWN = 0,
  HORIZONTAL_ONCLICK_TRIGGER_TYPE_ONCLICK_TRIGGER_TYPE_LEFT = 1,
  HORIZONTAL_ONCLICK_TRIGGER_TYPE_ONCLICK_TRIGGER_TYPE_MIDDLE = 2,
  HORIZONTAL_ONCLICK_TRIGGER_TYPE_ONCLICK_TRIGGER_TYPE_RIGHT = 3,
  HORIZONTAL_ONCLICK_TRIGGER_TYPE_ONCLICK_TRIGGER_TYPE_ALL_AREA = 4,
  UNRECOGNIZED = -1,
}

export enum ShowType {
  SHOW_TYPE_NORMAL = 0,
  SHOW_TYPE_FADE_IN_OUT = 1,
  UNRECOGNIZED = -1,
}

export enum RenderType {
  RENDER_TYPE_NATIVE = 0,
  RENDER_TYPE_HYBRID = 1,
  RENDER_TYPE_ALPHA = 2,
  UNRECOGNIZED = -1,
}

export enum IconDisplayType {
  ICON_DISPLAY_TYPE_IMAGE = 0,
  ICON_DISPLAY_TYPE_BADGE = 1,
  UNRECOGNIZED = -1,
}

export enum CommentTag {
  COMMENT_TAG_NORMAL = 0,
  COMMENT_TAG_CANDIDATE = 1,
  COMMENT_TAG_OVERAGE = 2,
  UNRECOGNIZED = -1,
}

export enum PerceptionDialogIconType {
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_NONE = 0,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_WARNING = 1,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_LINK_MIC = 2,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_GUEST_LINK_MIC = 3,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_LIVE = 4,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_TREASURE_BOX = 5,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_MUTE = 6,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_GAMEPAD_ACCESS_REVOKED = 7,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_BAN_REPORT_LIVE_SINGLE_ROOM = 8,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_BAN_REPORT_LIVE_ALL_ROOM = 9,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_BAN_REPORT_LIVE_GREEN_SCREEN = 10,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_GIFT = 11,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_APPEAL_SUCCESS = 12,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_MATCH = 13,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_LIVE_GOAL = 14,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_SUBSCRIPTION = 15,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_STAR_COMMENT = 16,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_RANKING = 17,
  PERCEPTION_DIALOG_ICON_TYPE_ICON_TYPE_COMMON = 18,
  UNRECOGNIZED = -1,
}

export enum GoalMessageSource {
  GOAL_MESSAGE_SOURCE_UNKNOWN = 0,
  GOAL_MESSAGE_SOURCE_COMMIT = 1,
  GOAL_MESSAGE_SOURCE_PROGRESS_UPDATE = 2,
  GOAL_MESSAGE_SOURCE_PIN = 3,
  GOAL_MESSAGE_SOURCE_UNPIN = 4,
  GOAL_MESSAGE_SOURCE_REVIEW_CALLBACK = 5,
  GOAL_MESSAGE_SOURCE_SUSPEND = 6,
  GOAL_MESSAGE_SOURCE_CHALLENGE_PROMPT = 7,
  UNRECOGNIZED = -1,
}

export enum ExhibitionType {
  EXHIBITION_TYPE_DEFAULT = 0,
  EXHIBITION_TYPE_FOLD = 1,
  EXHIBITION_TYPE_PUBLIC_SCREEN = 2,
  UNRECOGNIZED = -1,
}

export enum GiftSource {
  GIFT_SOURCE_UNKNOWN = 0,
  GIFT_SOURCE_PLATFORM = 1,
  GIFT_SOURCE_USER_BUY_RANDOM = 2,
  GIFT_SOURCE_USER_BUY_SPECIFIC = 3,
  UNRECOGNIZED = -1,
}

export enum MessageDisplayStyle {
  MESSAGE_DISPLAY_STYLE_DEFAULT = 0,
  MESSAGE_DISPLAY_STYLE_POPUP = 1,
  UNRECOGNIZED = -1,
}

export enum ProfitRankType {
  PROFIT_RANK_TYPE_TYPE_HOURLY_RANK = 0,
  PROFIT_RANK_TYPE_TYPE_WEEKLY_RANK = 1,
  PROFIT_RANK_TYPE_TYPE_HOURLY_STAR_RANK = 2,
  PROFIT_RANK_TYPE_TYPE_WEEKLY_RISING_RANK_ACTIVITY = 3,
  PROFIT_RANK_TYPE_TYPE_WEEKLY_RISING_RANK = 4,
  PROFIT_RANK_TYPE_TYPE_WEEKLY_ROOKIE = 5,
  PROFIT_RANK_TYPE_TYPE_E_COMMERCE_WEEKLY = 6,
  PROFIT_RANK_TYPE_TYPE_E_COMMERCE_DAILY = 7,
  PROFIT_RANK_TYPE_TYPE_DAILY_RANK = 8,
  PROFIT_RANK_TYPE_TYPE_FIRST_GIFT_RANK = 9,
  PROFIT_RANK_TYPE_TYPE_GAME_RANK = 10,
  PROFIT_RANK_TYPE_TYPE_DAILY_GAME = 11,
  PROFIT_RANK_TYPE_TYPE_HALL_OF_FAME_RANK = 12,
  PROFIT_RANK_TYPE_TYPE_RANK_LEAGUE = 13,
  PROFIT_RANK_TYPE_DAILY_ROOKIE = 14,
  PROFIT_RANK_TYPE_TYPE_TEAM_RANK = 15,
  PROFIT_RANK_TYPE_TYPE_CLASS_RANK = 16,
  PROFIT_RANK_TYPE_TYPE_DAILY_GAME_PUB_G = 20,
  PROFIT_RANK_TYPE_TYPE_DAILY_GAME_MLB_B = 21,
  PROFIT_RANK_TYPE_TYPE_DAILY_GAME_FREE_FIRE = 22,
  PROFIT_RANK_TYPE_TYPE_WEEKLY_GAME_SUBCATEGORY_ONE = 23,
  PROFIT_RANK_TYPE_TYPE_WEEKLY_GAME_SUBCATEGORY_TWO = 24,
  PROFIT_RANK_TYPE_TYPE_WEEKLY_GAME_SUBCATEGORY_THREE = 25,
  UNRECOGNIZED = -1,
}

export enum UnionAnimationInfoType {
  UNION_ANIMATION_INFO_TYPE_NO_UNION_ANIMATION = 0,
  UNION_ANIMATION_INFO_TYPE_LOOP = 1,
  UNION_ANIMATION_INFO_TYPE_LOCK = 2,
  UNRECOGNIZED = -1,
}

export enum DisplayStyle {
  DISPLAY_STYLE_NORMAL = 0,
  DISPLAY_STYLE_STAY = 1,
  DISPLAY_STYLE_CHAT = 2,
  UNRECOGNIZED = -1,
}

export enum HitABStatus {
  HIT_A_B_STATUS_HIT_AB_STATUS_NO_HIT = 0,
  HIT_A_B_STATUS_HIT_AB_STATUS_ENTER_FROM_EXTERNAL_LINK_NEW_TEXT = 1,
  HIT_A_B_STATUS_HIT_AB_STATUS_ENTER_FROM_RE_POST_NEW_TEXT = 2,
  UNRECOGNIZED = -1,
}

export enum PollKind {
  POLL_KIND_NORMAL = 0,
  POLL_KIND_GIFT = 1,
  POLL_KIND_CUSTOMIZABLE = 2,
  POLL_KIND_CUSTOMIZABLE_GIFT = 3,
  POLL_KIND_QUICK_GIFT = 4,
  POLL_KIND_EMOTE = 5,
  UNRECOGNIZED = -1,
}

export enum PollTemplateStatus {
  POLL_TEMPLATE_STATUS_TO_BE_REVIEWED = 0,
  POLL_TEMPLATE_STATUS_UNDER_REVIEW = 1,
  POLL_TEMPLATE_STATUS_REVIEWED = 2,
  POLL_TEMPLATE_STATUS_REFUSED = 3,
  UNRECOGNIZED = -1,
}

export enum PollAppealStatus {
  POLL_APPEAL_STATUS_UNKNOWN = 0,
  POLL_APPEAL_STATUS_PASS = 1,
  POLL_APPEAL_STATUS_FAIL = 2,
  UNRECOGNIZED = -1,
}

export enum RankTestMessageScene {
  RANK_TEST_MESSAGE_SCENE_UNKNOWN = 0,
  RANK_TEST_MESSAGE_SCENE_ONLINE_AUDIENCE_TOP_N_UPDATE_PUBLIC_SCREEN = 1,
  UNRECOGNIZED = -1,
}

export enum TriggerReason {
  TRIGGER_REASON_UNKNOWN = 0,
  TRIGGER_REASON_SCORE_UPDATE = 1,
  TRIGGER_REASON_BATTLE_END = 2,
  TRIGGER_REASON_OPT_OUT_UPDATE = 3,
  TRIGGER_REASON_KEEP_ALIVE = 4,
  UNRECOGNIZED = -1,
}

export enum Reason {
  REASON_TIME_UP = 0,
  REASON_CUT_SHORT = 1,
  UNRECOGNIZED = -1,
}

export enum BattleTaskMessageType {
  BATTLE_TASK_MESSAGE_TYPE_START = 0,
  BATTLE_TASK_MESSAGE_TYPE_TASK_UPDATE = 1,
  BATTLE_TASK_MESSAGE_TYPE_TASK_SETTLE = 2,
  BATTLE_TASK_MESSAGE_TYPE_REWARD_SETTLE = 3,
  UNRECOGNIZED = -1,
}

export enum RewardStatus {
  REWARD_STATUS_SUCCEED = 0,
  REWARD_STATUS_FAILED = 1,
  UNRECOGNIZED = -1,
}

export enum BattleAction {
  BATTLE_ACTION_UNKNOWN = 0,
  BATTLE_ACTION_INVITE = 1,
  BATTLE_ACTION_REJECT = 2,
  BATTLE_ACTION_CANCEL = 3,
  BATTLE_ACTION_OPEN = 4,
  BATTLE_ACTION_FINISH = 5,
  BATTLE_ACTION_CUT_SHORT = 6,
  BATTLE_ACTION_ACCEPT = 7,
  BATTLE_ACTION_QUIT_APPLY = 8,
  BATTLE_ACTION_DECLINE_QUIT = 9,
  BATTLE_ACTION_DECLINE_OFF_QUIT = 10,
  BATTLE_ACTION_LEAVE_LINK_MIC = 11,
  UNRECOGNIZED = -1,
}

export enum Result {
  RESULT_WIN = 0,
  RESULT_LOSE = 1,
  RESULT_DRAW = 2,
  UNRECOGNIZED = -1,
}

export enum GiftPermissionType {
  GIFT_PERMISSION_TYPE_UNKNOWN_TYPE = 0,
  GIFT_PERMISSION_TYPE_NO_GIFT_PERMISSION = 1,
  GIFT_PERMISSION_TYPE_ANCHOR_CLOSE = 2,
  GIFT_PERMISSION_TYPE_HAS_GIFT_PERMISSION = 3,
  GIFT_PERMISSION_TYPE_ANCHOR_BANNED = 4,
  UNRECOGNIZED = -1,
}

export enum BattleABTestType {
  BATTLE_A_B_TEST_TYPE_UNKNOWN_AB_TEST_TYPE = 0,
  BATTLE_A_B_TEST_TYPE_MEANWHILE_INVITE = 1,
  BATTLE_A_B_TEST_TYPE_SPECIFIED_GIFT = 2,
  BATTLE_A_B_TEST_TYPE_RT_C_MESSAGE_CHANNEL = 3,
  BATTLE_A_B_TEST_TYPE_CONNECTION_TIME_OUT = 4,
  BATTLE_A_B_TEST_TYPE_REMATCH_SKIP_TEAMMATE = 5,
  BATTLE_A_B_TEST_TYPE_OPT_INVITEE_4048 = 6,
  BATTLE_A_B_TEST_TYPE_BATTLE_AB_TEST_TYPE_TIME_CALIBRATE = 7,
  UNRECOGNIZED = -1,
}

export enum PlayScene {
  PLAY_SCENE_UNKNOWN = 0,
  PLAY_SCENE_COUNTDOWN_FOR_ALL = 1,
  PLAY_SCENE_COUNTDOWN_FOR_SINGLE = 2,
  PLAY_SCENE_LIVE_SHOW = 3,
  PLAY_SCENE_AIG_C = 4,
  PLAY_SCENE_KARAOKE = 5,
  PLAY_SCENE_DRAW_GUESS = 6,
  PLAY_SCENE_ENLARGE_GRID = 7,
  PLAY_SCENE_GIFT_PRIORITY_LINK = 8,
  PLAY_SCENE_GIFT_THRESHOLD_LINK = 9,
  PLAY_SCENE_NOTICE_BOARD = 10,
  PLAY_SCENE_PLAY_BOOK = 11,
  PLAY_SCENE_GUEST_SHOWDOWN = 12,
  UNRECOGNIZED = -1,
}

export enum LinkType {
  LINK_TYPE_TYPE_UNKNOWN = 0,
  LINK_TYPE_TYPE_VIDEO = 1,
  LINK_TYPE_TYPE_AUDIO = 2,
  LINK_TYPE_TYPE_VIRTUAL = 3,
  UNRECOGNIZED = -1,
}

export enum LinkSilenceStatus {
  LINK_SILENCE_STATUS_STATUS_UN_SILENCE = 0,
  LINK_SILENCE_STATUS_STATUS_SILENCE_BY_SELF = 1,
  LINK_SILENCE_STATUS_STATUS_SILENCE_BY_OWNER = 2,
  UNRECOGNIZED = -1,
}

export enum LinkmicRoleType {
  LINKMIC_ROLE_TYPE_ROLE_TYPE_UNKOWN = 0,
  LINKMIC_ROLE_TYPE_LEADER = 1,
  LINKMIC_ROLE_TYPE_PLAYER = 2,
  LINKMIC_ROLE_TYPE_INVITEE = 3,
  UNRECOGNIZED = -1,
}

export enum LinkRoleType {
  LINK_ROLE_TYPE_TYPE_ROLE_TYPE_UNKOWN = 0,
  LINK_ROLE_TYPE_TYPE_LEADER = 1,
  LINK_ROLE_TYPE_TYPE_PLAYER = 2,
  LINK_ROLE_TYPE_TYPE_INVITEE = 3,
  LINK_ROLE_TYPE_TYPE_APPLIER = 4,
  UNRECOGNIZED = -1,
}

export enum MuteStatus {
  MUTE_STATUS_MUTE = 0,
  MUTE_STATUS_UN_MUTE = 1,
  UNRECOGNIZED = -1,
}

export enum GuestMicCameraManageOp {
  GUEST_MIC_CAMERA_MANAGE_OP_OPEN_MIC = 0,
  GUEST_MIC_CAMERA_MANAGE_OP_OPEN_CAMERA = 1,
  GUEST_MIC_CAMERA_MANAGE_OP_CLOSE_MIC = 2,
  GUEST_MIC_CAMERA_MANAGE_OP_CLOSE_CAMERA = 3,
  GUEST_MIC_CAMERA_MANAGE_OP_CLOSE_MIC_PUNISH = 4,
  UNRECOGNIZED = -1,
}

export enum GuestMicCameraChangeScene {
  GUEST_MIC_CAMERA_CHANGE_SCENE_CHANGE_SCENE_UNKNOWN = 0,
  GUEST_MIC_CAMERA_CHANGE_SCENE_LIVE_SHOW_BY_ANCHOR_AUTO = 1,
  GUEST_MIC_CAMERA_CHANGE_SCENE_LIVE_SHOW_BY_SERVER_NORMAL = 2,
  GUEST_MIC_CAMERA_CHANGE_SCENE_LIVE_SHOW_BY_SHOW_END = 3,
  UNRECOGNIZED = -1,
}

export enum LinkMicUserAdminType {
  LINK_MIC_USER_ADMIN_TYPE_UNDEFINED_TYPE = 0,
  LINK_MIC_USER_ADMIN_TYPE_MANAGER_TYPE = 1,
  LINK_MIC_USER_ADMIN_TYPE_HOST_TYPE = 2,
  UNRECOGNIZED = -1,
}

export enum LinkmicMultiLiveEnum {
  LINKMIC_MULTI_LIVE_ENUM_DEFAULT = 0,
  LINKMIC_MULTI_LIVE_ENUM_ANCHOR_USE_NEW_LAYOUT = 1,
  UNRECOGNIZED = -1,
}

export enum PollEndType {
  POLL_END_TYPE_POLL_END_BY_TIME = 0,
  POLL_END_TYPE_POLL_END_BY_OWNER = 1,
  POLL_END_TYPE_POLL_END_BY_OTHER = 2,
  POLL_END_TYPE_POLL_END_BY_ADMIN = 3,
  UNRECOGNIZED = -1,
}

export enum CohostABTestType {
  COHOST_A_B_TEST_TYPE_COHOST_AB_TEST_TYPE_UNKNOWN = 0,
  COHOST_A_B_TEST_TYPE_COHOST_AB_TEST_TYPE_LINK_TIME_OUT_STRATEGY = 1,
  COHOST_A_B_TEST_TYPE_COHOST_AB_TEST_TYPE_COHOST_RESERVATION = 2,
  COHOST_A_B_TEST_TYPE_COHOST_AB_TEST_TYPE_QUICK_PAIR_NEW_ARCH_SWITCH = 3,
  COHOST_A_B_TEST_TYPE_COHOST_AB_TEST_TYPE_COHOST_INVITATION_TEXT = 4,
  UNRECOGNIZED = -1,
}

export enum OptPairStatus {
  OPT_PAIR_STATUS_UNKNOWN = 0,
  OPT_PAIR_STATUS_OFFLINE = 1,
  OPT_PAIR_STATUS_FINISHED = 2,
  UNRECOGNIZED = -1,
}

export enum ContentPositionType {
  CONTENT_POSITION_TYPE_UNKNOWN = 0,
  CONTENT_POSITION_TYPE_STREAM = 1,
  CONTENT_POSITION_TYPE_LIVE_STUDIO_STREAM_PORTRAIT = 2,
  CONTENT_POSITION_TYPE_LIVE_STUDIO_STREAM_LANDSCAPE = 3,
  UNRECOGNIZED = -1,
}

export enum MultiGuestOutsideRoomInviteSource {
  MULTI_GUEST_OUTSIDE_ROOM_INVITE_SOURCE_OUTSIDE_ROOM_INVITE_SOURCE_UNKNOWN = 0,
  MULTI_GUEST_OUTSIDE_ROOM_INVITE_SOURCE_OUTSIDE_ROOM_INVITE_SOURCE_PANEL = 1,
  MULTI_GUEST_OUTSIDE_ROOM_INVITE_SOURCE_OUTSIDE_ROOM_INVITE_SOURCE_CAPSULE = 2,
  MULTI_GUEST_OUTSIDE_ROOM_INVITE_SOURCE_OUTSIDE_ROOM_INVITE_SOURCE_EMPTY_POSITION = 3,
  UNRECOGNIZED = -1,
}

export enum LinkUserType {
  LINK_USER_TYPE_DEFAULT = 0,
  LINK_USER_TYPE_KARAOKE = 1,
  UNRECOGNIZED = -1,
}

export enum ContentInviteSource {
  CONTENT_INVITE_SOURCE_INVITE_SOURCE_UNKNOWN = 0,
  CONTENT_INVITE_SOURCE_INVITE_SOURCE_PANEL_GO_LIVE = 1,
  CONTENT_INVITE_SOURCE_INVITE_SOURCE_MUTUAL_NOTICE = 2,
  CONTENT_INVITE_SOURCE_INVITE_SOURCE_USER_PROFILE = 3,
  CONTENT_INVITE_SOURCE_INVITE_SOURCE_RESERVE = 4,
  UNRECOGNIZED = -1,
}

export enum LinkmicShareRevenueSetting {
  LINKMIC_SHARE_REVENUE_SETTING_LINK_MIC_SHARE_REVENUE_NOT_SET = 0,
  LINKMIC_SHARE_REVENUE_SETTING_LINK_MIC_SHARE_REVENUE_OPEN = 1,
  LINKMIC_SHARE_REVENUE_SETTING_LINK_MIC_SHARE_REVENUE_CLOSE = 2,
  UNRECOGNIZED = -1,
}

export enum PosIdentityType {
  POS_IDENTITY_TYPE_IDENTITY_EMPTY_SLOT = 0,
  POS_IDENTITY_TYPE_IDENTITY_RT_C_USER_ID = 1,
  POS_IDENTITY_TYPE_IDENTITY_RT_C_STREAM_ID = 2,
  POS_IDENTITY_TYPE_IDENTITY_LIVE_USER_ID = 3,
  UNRECOGNIZED = -1,
}

export enum JoinType {
  JOIN_TYPE_UNKNOWN = 0,
  JOIN_TYPE_CHANNEL_APPLY = 1,
  JOIN_TYPE_CHANNEL_INVITE = 2,
  JOIN_TYPE_GROUP_APPLY = 100,
  JOIN_TYPE_GROUP_APPLY_FOLLOW = 101,
  JOIN_TYPE_GROUP_INVITE = 102,
  JOIN_TYPE_GROUP_INVITE_FOLLOW = 103,
  JOIN_TYPE_GROUP_OWNER_JOIN = 104,
  UNRECOGNIZED = -1,
}

export enum CohostLayoutMode {
  COHOST_LAYOUT_MODE_NORMAL = 0,
  COHOST_LAYOUT_MODE_SCREEN_SHARE = 1,
  UNRECOGNIZED = -1,
}

export enum TagClassification {
  TAG_CLASSIFICATION_UNKNOWN = 0,
  TAG_CLASSIFICATION_COHOST_HISTORY = 1,
  TAG_CLASSIFICATION_FIRST_DEGREE_RELATION = 2,
  TAG_CLASSIFICATION_SECOND_DEGREE_RELATION = 3,
  TAG_CLASSIFICATION_RANK = 4,
  TAG_CLASSIFICATION_SIMILAR_INTERESTS = 5,
  UNRECOGNIZED = -1,
}

export enum SourceType {
  SOURCE_TYPE_UNKNOWN = 0,
  SOURCE_TYPE_FRIEND_LIST = 1,
  SOURCE_TYPE_RECOMMEND_LIST = 2,
  SOURCE_TYPE_RECENT = 3,
  SOURCE_TYPE_OTHER_FOLLOW = 4,
  SOURCE_TYPE_QUICK_PAIR = 5,
  SOURCE_TYPE_ACTIVITY = 6,
  SOURCE_TYPE_QUICK_RECOMMEND = 7,
  SOURCE_TYPE_OFFICIAL_CHANNEL = 8,
  SOURCE_TYPE_BEST_TEAMMATE = 9,
  SOURCE_TYPE_RESERVATION = 10,
  SOURCE_TYPE_PAIRING = 11,
  SOURCE_TYPE_PAIRING_ON_RESERVATION = 12,
  SOURCE_TYPE_TOPIC_QUICK_PAIR = 13,
  SOURCE_TYPE_TOPIC_QUICK_RECOMMEND = 14,
  SOURCE_TYPE_ONLINE_FRIEND_CAPSULE = 15,
  SOURCE_TYPE_WEEKLY_RANK = 20,
  SOURCE_TYPE_HOURLY_RANK = 21,
  SOURCE_TYPE_WEEKLY_RISING = 23,
  SOURCE_TYPE_WEEKLY_ROOKIE = 24,
  SOURCE_TYPE_CONNECTION_LIST = 25,
  SOURCE_TYPE_DAILY_RANK = 26,
  SOURCE_TYPE_DAILY_RANK_HALL_OF_FAME = 27,
  SOURCE_TYPE_RESERVATION_BUBBLE = 28,
  SOURCE_TYPE_PAIRING_BUBBLE = 29,
  SOURCE_TYPE_LEAGUE_PHASE_ONE = 30,
  SOURCE_TYPE_LEAGUE_PHASE_TWO = 31,
  SOURCE_TYPE_LEAGUE_PHASE_THREE = 32,
  SOURCE_TYPE_DAILY_ROOKIE = 33,
  SOURCE_TYPE_MAY_KNOW_LIST = 34,
  SOURCE_TYPE_BANNER = 35,
  SOURCE_TYPE_FANS_TEAM_RANK = 36,
  SOURCE_TYPE_SEARCH = 37,
  SOURCE_TYPE_E_OY_RANK_LIST = 38,
  SOURCE_TYPE_LEAGUE_CAMPAIGN_RANK = 39,
  SOURCE_TYPE_CREATOR_CLASS_RANK = 40,
  SOURCE_TYPE_HISTORY = 41,
  SOURCE_TYPE_QUICK_RECOMMEND_DURING_COHOST = 43,
  UNRECOGNIZED = -1,
}

export enum BattleType {
  BATTLE_TYPE_UNKNOWN_BATTLE_TYPE = 0,
  BATTLE_TYPE_NORMAL_BATTLE = 1,
  BATTLE_TYPE_TEAM_BATTLE = 2,
  BATTLE_TYPE_INDIVIDUAL_BATTLE = 3,
  BATTLE_TYPE_1_V_N = 4,
  BATTLE_TYPE_TAKE_THE_STAGE = 51,
  BATTLE_TYPE_GROUP_SHOW = 52,
  UNRECOGNIZED = -1,
}

export enum BattleInviteType {
  BATTLE_INVITE_TYPE_NORMAL = 0,
  BATTLE_INVITE_TYPE_AGAIN = 1,
  UNRECOGNIZED = -1,
}
